import Units from "../../../utils/Units";
import Time from "../axes/Time";
import Voltage from "../axes/Voltage";

let DeviceVoltage = {
    type: "line",
    label: "Device Voltage",
    fill: false,
    lineTension: 0,
    colorPalette: 9,
    borderWidth:1,

    pointStyle: "circle",
    pointRadius:0,
    pointHoverRadius: 2,
    pointBorderWidth:.5,
    z:50,

    tooltipLabelValueCallback: (value) => {
        return Units.rounded(value,2);
    },

    yAxis:Voltage,
    xAxis:Time
};

export default DeviceVoltage;



// WEBPACK FOOTER //
// ./src/components/chart/channels/DeviceVoltage.js